import React from 'react';
import { Card, Dropdown } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { HiExclamationCircle } from "react-icons/hi2";
import { HiDotsVertical } from "react-icons/hi";
import { PiNotePencil } from "react-icons/pi";
import { IoPlayCircleOutline } from "react-icons/io5";
import { CustomButtonToggle, CustomMenu } from '../../DropdownComponents';
import CustomButton from '../../CustomButton';

const MobileEventCard = ({
	event,
	typeFormatter,
	timestampFormatter,
	durationFormatter,
	actionsFormatter,
	tripFormatter,
}) => {
	const { t } = useTranslation('translation', { keyPrefix: 'eventsPage.eventClipsContainer.eventClipsTable' });

	const eventType = typeFormatter(null, event);
	const eventTime = timestampFormatter(event.timestamp);
	const actionItems = actionsFormatter(null, event, true);
	const tripElement = tripFormatter ? tripFormatter(null, event) : null;
	const entries = Object.entries(actionItems).filter(([key, item]) => key !== 'playButton' && item !== null && item !== undefined);

	const dataCells = [
		{ label: t('labelGroups'), value: event.groups },
		{ label: t('labelDuration'), value: durationFormatter(null, event) },
		{ label: t('labelID'), value: event.id },
	];

	return (
		<Card className="mobile-grid-card">
			<Card.Body>
				<div className="event-header">
					<div className="event-icon"></div>
					<div className="event-header-data">
						<span className="event-type">{eventType}</span>
						<span className="event-time">{eventTime}</span>
					</div>
				</div>
				<div className="event-data">
					{dataCells.map(({ label, value }) => (
						<div className="event-data-cell" key={label}>
							<div className="data-item">
								<span className="label">{label}</span>
								<span className="value">{value}</span>
							</div>
						</div>
					))}
				</div>
				<div className="event-card-actions">
					<div className="revieved-section">
						<HiExclamationCircle size={18} />
						<span>{t('textNotReviewed')}</span>
					</div>
					<div className="actions-section">
						{actionItems.playButton && (
							<CustomButton variant="primary" prefix="play-button-mobile" onClick={() => actionItems.playButton.onClick()}>
								<IoPlayCircleOutline size={18} />
								<span>{t('viewVideo')}</span>
							</CustomButton>
						)}
						{tripElement && (
							<div className="view-trip">
								{tripElement}
							</div>
						)}
						{!!entries.length && (
							<Dropdown>
								<Dropdown.Toggle as={CustomButtonToggle} variant="tertiary" size="icon" prefix="event-card-menu-toggle">
									<HiDotsVertical size={18} />
								</Dropdown.Toggle>
								<Dropdown.Menu as={CustomMenu} align="end">
									{entries.map(([key, item]) => {
										const hasIconChildren = item.children && typeof item.children !== 'string';
										return (
											<Dropdown.Item key={key} onClick={() => item.onClick()}>
												{key === 'noteButton'
													? <span className={`imageButton-icon imageButton ${key} ${item.className || ''}`}><PiNotePencil size={16} color="#fff" /></span>
													: hasIconChildren
														? <span className={`imageButton-icon ${key} ${item.className || ''}`}>{item.children}</span>
														: <span className={`imageButton ${key} ${item.className || ''}`} />}
												<span>{item.label || item.children}</span>
											</Dropdown.Item>
										)
									})}
								</Dropdown.Menu>
							</Dropdown>
						)}
					</div>
				</div>
			</Card.Body>
		</Card>
	);
};

export default MobileEventCard;
